<template>
  <div class="dialog-dhl">
    <div class="dialog-dhl-actions">
      <el-button type="primary" size="small" @click="getPdf()">{{ $t('invoice.detail.generatePdf') }}</el-button>
    </div>
    <div class="dhl-page" id="pdfDom">
      <!-- 标题 -->
      <div class="dhl-header">
        <h1 class="dhl-title">Commercial Invoice</h1>
        <div class="dhl-meta">
          <span><b>AWB No:</b> {{ order_info.platform_order_sn }}</span>
          <span style="margin-left: 20px;"><b>Invoice Date:</b> {{ order_info.createtime }}</span>
          <span style="margin-left: 20px;"><b>Invoice No:</b> {{ invoiceNo }}</span>
        </div>
      </div>

      <!-- 发件人 / 收件人 -->
      <div class="dhl-address-row">
        <div class="dhl-address-col">
          <div class="dhl-section-label">SHIP FROM:</div>
          <div>{{ send_data.realname }}</div>
          <div>{{ send_data.company }}</div>
          <div>{{ send_data.address_one }}</div>
          <div v-if="send_data.address_two">{{ send_data.address_two }}</div>
          <div class="dhl-gap"></div>
          <div>{{ send_data.city }}, {{ send_data.zcode }}</div>
          <div>{{ send_data.province }}</div>
          <div>{{ send_data.country }}</div>
          <div>{{ send_data.mobile }}</div>
          <div class="dhl-gap"></div>
          <div>Trader Type:</div>
          <div>VAT No:</div>
          <div>EORI:</div>
          <div>TAX ID:</div>
        </div>
        <div class="dhl-address-col">
          <div class="dhl-section-label">SHIP TO:</div>
          <div>{{ receive_data.realname }}</div>
          <div>{{ receive_data.company }}</div>
          <div>{{ receive_data.address_one }}</div>
          <div v-if="receive_data.address_two">{{ receive_data.address_two }}</div>
          <div class="dhl-gap"></div>
          <div>{{ receive_data.city }}, {{ receive_data.zcode }}</div>
          <div>{{ receive_data.province }}</div>
          <div>{{ receive_data.country }}</div>
          <div>{{ receive_data.mobile }}</div>
          <div class="dhl-gap"></div>
          <div>Trader Type:</div>
          <div>VAT No:</div>
          <div>EORI:</div>
        </div>
      </div>

      <!-- 参考信息 -->
      <div class="dhl-ref-section">
        <div><b>Shipper Reference:</b></div>
        <div><b>Receiver Reference:</b></div>
        <div style="margin-top: 6px;"><b>Remarks:</b></div>
      </div>

      <!-- 货物明细表 -->
      <table class="dhl-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Description</th>
            <th>Commo-<br>dity Code</th>
            <th>GST<br>paid</th>
            <th>Net /<br>Gross<br>Weight</th>
            <th>COO</th>
            <th>Reference Type &<br>ID</th>
            <th>QTY</th>
            <th>Unit<br>Value</th>
            <th>Sub Total<br>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in project_info.project_list" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.product_info }}</td>
            <td></td>
            <td></td>
            <td>{{ item.suttle }} lb<br>{{ item.suttle }} lb</td>
            <td>{{ resolveOrigin(item.chandi) }}</td>
            <td></td>
            <td>{{ item.num }} {{ item.unit_of === 'pieces' ? 'PCS' : item.unit_of }}</td>
            <td>{{ formatPrice(getUnitValue(item)) }}<br>USD</td>
            <td>{{ formatPrice(item.total_price_all) }}<br>USD</td>
          </tr>
        </tbody>
      </table>

      <!-- 汇总信息 -->
      <div class="dhl-summary">
        <div class="dhl-summary-left">
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total Goods Value:</span>
            <span>{{ formatPrice(project_info.total_amount) }} USD</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total Invoice Amount:</span>
            <span>{{ formatPrice(project_info.total_amount) }} USD</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Currency Code:</span>
            <span>USD</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Terms of Payment:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Terms of Trade:</span>
            <span>DAP</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Place of Incoterm:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Reason for Export:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Type of Export:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total Net Weight:</span>
            <span>{{ project_info.total_pa_lb }} lb</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total Gross Weight:</span>
            <span>{{ project_info.total_pa_lb }} lb</span>
          </div>
        </div>
        <div class="dhl-summary-right">
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total line items:</span>
            <span>{{ project_info.project_list ? project_info.project_list.length : 0 }}</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Number of Pallets:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Total units:</span>
            <span>{{ project_info.total_num }}</span>
          </div>
          <div class="dhl-summary-row">
            <span class="dhl-summary-label">Package Marks / Other Info:</span>
            <span></span>
          </div>
          <div class="dhl-summary-row" style="margin-top: 40px;">
            <span class="dhl-summary-label">Payer of GST / VAT:</span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { invoiceDetails } from '@/api/invoice'
export default {
  props: {
    id: {
      type: [Number, String],
      default: ''
    },
    order_sn: {
      type: [Number, String],
      default: ''
    },
    platform_order_sn: {
      type: [Number, String],
      default: ''
    },
    invoiceData: {
      type: Object,
      default: null
    },
    // 系统支持的"产地"国家英文全名白名单。chandi 不在此白名单内时，渲染为空（不再硬塞 'US' 默认值）
    countryWhitelist: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      htmlTitle: 'DHL-Commercial-Invoice',
      order_info: {},
      send_data: {},
      receive_data: {},
      project_info: {},
      addtime: '',
      invoiceNo: ''
    }
  },
  mounted() {
    const trackNo = this.platform_order_sn
    if (trackNo) {
      this.htmlTitle = trackNo + ' DHL-Commercial-Invoice'
    }
    if (this.invoiceData) {
      this.setData(this.invoiceData)
    } else {
      this.getInvoiceDetails()
    }
  },
  methods: {
    getUnitValue(item) {
      const quantity = Number(item && item.num)
      const totalValue = Number(item && item.unit_price)
      return quantity > 0 ? Math.round((totalValue / quantity) * 100) / 100 : 0
    },
    formatPrice(val) {
      if (!val && val !== 0) return '0.000'
      return Number(val).toFixed(3)
    },
    // 渲染"产地"列：chandi 必须在国家白名单内才显示，否则留空（避免脏数据 / 非白名单值误导用户）
    // 白名单未加载（length=0）时降级为原值显示，避免接口失败导致全部产地空白。
    resolveOrigin(chandi) {
      if (!chandi) return ''
      if (Array.isArray(this.countryWhitelist) && this.countryWhitelist.length > 0) {
        return this.countryWhitelist.includes(chandi) ? chandi : ''
      }
      return chandi
    },
    setData(data) {
      this.order_info = data.order_info
      const trackNo = this.platform_order_sn || data.order_info.platform_order_sn
      this.htmlTitle = trackNo ? (trackNo + ' DHL-Commercial-Invoice') : 'DHL-Commercial-Invoice'
      this.send_data = data.order_info.send_data
      this.receive_data = data.order_info.receive_data
      this.project_info = data.project_info
      this.addtime = data.addtime
      this.invoiceNo = data.order_info.invoice_no || ''
    },
    getInvoiceDetails() {
      invoiceDetails({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        id: this.id,
        order_sn: this.order_sn
      }).then(res => {
        if (res.code == 1) {
          this.setData(res.data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-dhl {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
}

.dialog-dhl-actions {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 10px;
  background: #fff;
}

.dhl-page {
  width: 210mm;
  min-height: 279mm;
  margin: 0 auto;
  padding: 20px 30px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: #000;
  background: #fff;
}

.dhl-header {
  margin-bottom: 20px;
}

.dhl-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 8px 0;
}

.dhl-meta span {
  font-size: 12px;
}

.dhl-address-row {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.dhl-address-col {
  width: 48%;
  font-size: 12px;
  line-height: 1.6;
}

.dhl-section-label {
  font-weight: bold;
  margin-bottom: 4px;
}

.dhl-gap {
  height: 10px;
}

.dhl-ref-section {
  margin: 20px 0;
  font-size: 12px;
  line-height: 1.8;
}

.dhl-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 11px;
}

.dhl-table th,
.dhl-table td {
  border: 1px solid #000;
  padding: 6px 8px;
  text-align: center;
  vertical-align: middle;
}

.dhl-table th {
  background: #f5f5f5;
  font-weight: bold;
  font-size: 11px;
}

.dhl-table td {
  font-size: 12px;
}

.dhl-summary {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 12px;
}

.dhl-summary-left,
.dhl-summary-right {
  width: 48%;
}

.dhl-summary-row {
  display: flex;
  margin: 3px 0;
}

.dhl-summary-label {
  min-width: 160px;
  font-weight: normal;
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  .dhl-page {
    page-break-after: always;
    page-break-inside: avoid;
  }
}
</style>
